export const queryCommonFlags = {
  refetchOnWindowFocus: false,
  refetchOnMount: false,
};
